module.exports = __webpack_public_path__ + "img/00027.b72ff3b7.webp";